import script from "./Close.vue?vue&type=script&setup=true&lang=js"
export * from "./Close.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__